import type { StyleSpecification } from 'mapbox-gl';

export const SATELLITE_SOURCE = 'satellite-pur';
export const LYON_CENTER: [number, number] = [4.832, 45.7578];
export const LYON_BOUNDS: [[number, number], [number, number]] = [
  [4.811, 45.746],
  [4.855, 45.773],
];

export function createSatelliteStyle(token: string): StyleSpecification {
  return {
    version: 8,
    name: 'Mapbox Satellite pur',
    sources: {
      [SATELLITE_SOURCE]: {
        type: 'raster',
        tiles: [
          `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.jpg90?access_token=${encodeURIComponent(token)}`,
        ],
        // Retina tiles contain 512 pixels but cover a logical 256-pixel tile.
        tileSize: 256,
        minzoom: 0,
        maxzoom: 22,
        attribution: '© <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noopener noreferrer">Mapbox</a> © Maxar',
      },
    },
    layers: [
      {
        id: 'satellite-imagery',
        type: 'raster',
        source: SATELLITE_SOURCE,
        paint: { 'raster-resampling': 'linear' },
      },
    ],
  };
}
